export default "__VITE_ASSET__38c3daa4__"